function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useEffect, useState, useContext, useCallback } from 'react';
import { context } from 'dumi/theme';
import Previewer from 'dumi-theme-default/es/builtins/Previewer';
import debounce from 'lodash.debounce';
import './Previewer.less';
export var ACTIVE_MSG_TYPE = 'dumi:scroll-into-demo';
export default (function (props) {
  var ref = useRef();

  var _useContext = useContext(context),
      meta = _useContext.meta;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      previewerProps = _useState2[0],
      setPreviewerProps = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isActive = _useState4[0],
      setIsActive = _useState4[1];

  var isInactive = meta.mobile !== false && !isActive;
  var activeSelf = useCallback(function () {
    window.postMessage({
      type: ACTIVE_MSG_TYPE,
      value: JSON.stringify({
        identifier: props.identifier,
        demoUrl: props.demoUrl,
        simulator: props.simulator
      })
    }, '*');
    setIsActive(true);
  }, [props]);
  useEffect(function () {
    var _window;

    // skip if page not loaded

    /* istanbul ignore next */
    if (!meta.title) return;
    var isFirstDemo = document.querySelector('.__dumi-default-mobile-previewer') === ref.current;
    var handler = debounce(function () {
      var _ref$current, _ref$current2, _ref$current2$previou, _ref$current3, _ref$current4;

      var navHeight = 64; // for active by previous title anchor

      var scrollTop = document.documentElement.scrollTop;
      var refElmTop = ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect().top) + scrollTop; // do not offset front if the previous element is same the previewer

      var edgeOffset = ((_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : (_ref$current2$previou = _ref$current2.previousElementSibling) === null || _ref$current2$previou === void 0 ? void 0 : _ref$current2$previou.className) === ((_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.className) ? navHeight : navHeight + 128; // post message if scroll into current demo

      if ( // fallback to first demo
      isFirstDemo && scrollTop < refElmTop || // detect scroll position
      scrollTop + edgeOffset > refElmTop && scrollTop + navHeight < refElmTop + (ref === null || ref === void 0 ? void 0 : (_ref$current4 = ref.current) === null || _ref$current4 === void 0 ? void 0 : _ref$current4.offsetHeight)) {
        activeSelf();
      } else {
        setIsActive(false);
      }
    }, 50);

    if ( // only render mobile phone when screen max than 960px
    ((_window = window) === null || _window === void 0 ? void 0 : _window.outerWidth) > 960 && // do not disable mobile simulator
    meta.mobile !== false) {
      // active source code wrapper if scroll into demo
      handler();
      window.addEventListener('scroll', handler); // rewrite props for device mode

      setPreviewerProps(Object.assign({}, props, {
        // omit iframe
        iframe: null,
        // omit children
        children: null,
        // show source code
        defaultShowCode: true,
        // hide external action
        hideActions: ['EXTERNAL'].concat(props.hideActions)
      }));
    } else {
      // use standard mode if screen min than 960px
      setPreviewerProps(props);
    }

    return function () {
      return window.removeEventListener('scroll', handler);
    };
  }, [props, meta]);
  useEffect(function () {
    var handler = function handler(ev) {
      if (ev.data.type === ACTIVE_MSG_TYPE && isActive && JSON.parse(ev.data.value).identifier !== props.identifier) {
        setIsActive(false);
      }
    };

    window.addEventListener('message', handler);
    return function () {
      return window.removeEventListener('message', handler);
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: meta.mobile !== false ? '__dumi-default-mobile-previewer' : null,
    onClick: function onClick() {
      if (isInactive) {
        activeSelf();
      }
    },
    "data-inactive": isInactive || undefined,
    ref: ref
  }, previewerProps && /*#__PURE__*/React.createElement(Previewer, _extends({
    className: isActive ? '__dumi-default-previewer-target' : null
  }, previewerProps)));
});